/** @jsxImportSource @emotion/react */
import { FC } from "react";
import TextInput, { TextInputProps } from "./TextInput";

const FloatInput: FC<TextInputProps> = ({ value, ...props }) => {
  return <TextInput {...props} value={value || ""} type="number" />;
};

export default FloatInput;
